import dataStore from '../../store/dataStore.ts'
import controlStore from '../../store/controlStore.ts'
import React from 'react'
import { editStyle, showStyle } from './helpers/safeZoneHelper.ts'
import { SafeZonePolygon } from './mapComponents/SafeZonePolygon.tsx'
import safeZoneStore from '../../store/safeZoneStore.ts'

export const SafeZones = () => {
    const safeZones = dataStore(s => s.safeZones)
    const editingSafeZoneId = safeZoneStore(s => s.safeZoneBeingEdited)
    const showSafeZones = controlStore(s => s.showSafeZones)

    // Single effect: rebuild polygons whenever any input changes. No clear/setTimeout flicker.
    const polygons = React.useMemo(() => {
        if (!showSafeZones || !safeZones?.length) return []
        return safeZones.map(zone => {
            const style = zone._id === editingSafeZoneId ? editStyle : showStyle
            return <SafeZonePolygon key={zone._id} zone={zone} options={style}/>
        })
    }, [safeZones, showSafeZones, editingSafeZoneId])

    // Keep the store in sync for any consumers that read safeZonePolygons directly.
    React.useEffect(() => {
        safeZoneStore.getState().setSafeZonePolygons(polygons)
    }, [polygons])

    return <>{polygons}</>
}
